import { useTestFormSectionStyles } from './TestFormSectionStyles';
import FormSection from '../../../../../form/FormSection';

function TestFormSection(props) {
    const classes = useTestFormSectionStyles();

    return (
        <FormSection
            sectionContainerClassName={classes.testFormSection}
            fieldsClassName={classes.testSubSectionContainer}
            {...props}
        />
    );
}

export default TestFormSection;
